import { Link } from "react-router-dom";
import { BlogPost } from "@/data/blogPosts";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { getPostKicker } from "@/utils/postKicker";

interface NewsCardProps {
  post: BlogPost;
}

const NewsCard = ({ post }: NewsCardProps) => {
  return (
    <Link to={`/blog/${post.slug}`} className="h-full">
      <div className="group cursor-pointer h-full flex flex-col hover:opacity-80 transition-opacity">
        <div className="relative overflow-hidden">
          <AspectRatio ratio={16 / 9}>
            <img 
              src={post.image} 
              alt={post.title}
              className="object-cover w-full h-full grayscale group-hover:grayscale-0 transition-all duration-500"
            />
          </AspectRatio>
        </div>
        
        <div className="py-6 space-y-3">
          <p className="text-[10px] tracking-[0.2em] uppercase text-primary/50 font-medium">
            {getPostKicker(post)}
          </p>
          <h4 className="text-xl sm:text-2xl font-light text-foreground leading-tight line-clamp-2">
            {post.title}
          </h4>
          <p className="text-base text-muted-foreground font-light leading-relaxed line-clamp-3">
            {post.description}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default NewsCard;
